let AnnotationUtil = require("../util/AnnotationUtil");
let SubjectResponses = require("../widget/SubjectResponses");

let Table = mc.widgets.Table;

let SubjectAnnotations = function (props) {
  let {
    subject,
    annotations,
    activities,
    category,
    term,
    direction,
    onSort,
    isModal
  } = props;

  let cols = [
    {
      prop: "startTs",
      label: tx("date_time"),
      content: function (anno) {
        let startTs = anno.startTs;
        let studyId = subject.studyId;
        let subjectId = subject.id;

        return (
          <a href={mc.router.resolve("RECORDING_DATA_VIEW", { studyId, subjectId, startTs })}>
            {mc.format.datetime(startTs, subject.timezone)}
          </a>
        );
      },
      width: "35%",
      sort: true
    },
    {
      prop: "desc",
      label: tx("description"),
      content: function (anno) {
        let viewQuestions = function () {
          mc.ui.modal(<SubjectResponses annotation={anno.detail}/>);
        };

        return (
          <span>
            {anno.desc}
            {!isModal && anno.hasQuestions && (
              <small className="rc-subject-data-qa">
                <a onClick={viewQuestions}>{tx("q/a")}</a>
              </small>
            )}
          </span>
        );
      },
      width: "40%"
    },
    {
      prop: "duration",
      label: tx("duration"),
      content: function (anno) {
        return anno.duration > 0 ? mc.format.duration(anno.duration) : "-";
      },
      width: "25%"
    }
  ];

  let results = annotations.map(function (result) {
    let startTs = result.startTs;
    let stopTs = result.stopTs;
    let type = result.event ? result.event.type : null;
    let desc = AnnotationUtil.getDescription(result);
    let hasQuestions = type === "diary" || (type === "activity" && !!activities.find(function (a) {
      return a.id === result.event.id && a.questions.length > 0;
    }));

    return {
      startTs,
      duration: stopTs - startTs,
      detail: result,
      id: result.id,
      type,
      desc: desc || tx("N/A"),
      hasQuestions
    };
  }).filter(function (result) {
    let categories = {
      "activity": "activities",
      "diary": "diaries",
      "subject": "labels",
      "recording": "labels"
    };

    return categories[result.type] === category;
  });

  return (
    <Table
      data={mc.utils.filter(results, ["desc"], term)}
      cols={cols}
      sort="startTs"
      direction={direction}
      onSort={onSort}
      align="middle"/>
  );
};

module.exports = SubjectAnnotations;